import React from 'react';
import { Bar } from 'react-chartjs-2';
import {
  Chart as ChartJS,
  BarElement,
  CategoryScale,
  LinearScale,
  Title,
  Tooltip,
  Legend,
} from 'chart.js';

ChartJS.register(BarElement, CategoryScale, LinearScale, Title, Tooltip, Legend);

// Sample data (replace or import as needed)
const rawData = {
  visit: [
    { id: 1, start_datetime: '2025-05-27 10:15:00', visitors: 1, amenity: 'clubhouse-pool--jacuzzi' },
    { id: 2, start_datetime: '2025-05-27 11:45:00', visitors: 1, amenity: 'clubhouse-pool--jacuzzi' },
    { id: 3, start_datetime: '2025-05-28 11:50:00', visitors: 1, amenity: 'clubhouse-pool--jacuzzi' },
    { id: 4, start_datetime: '2025-06-02 15:20:00', visitors: 1, amenity: 'clubhouse-pool--jacuzzi' },
    { id: 5, start_datetime: '2025-06-02 15:35:00', visitors: 1, amenity: 'clubhouse-pool--jacuzzi' },
    { id: 6, start_datetime: '2025-06-02 10:05:00', visitors: 1, amenity: 'clubhouse-pool--jacuzzi' },
    { id: 7, start_datetime: '2025-06-03 10:20:00', visitors: 1, amenity: 'clubhouse-pool--jacuzzi' },
  ],
};

const PoolVisitsByHourAndDayChart = () => {
  // 1. Filter
  const filtered = rawData.visit.filter(
    (v) => v.amenity === 'clubhouse-pool--jacuzzi'
  );

  // 2. Group data by day and hour
  const dayHourMap = {}; // { '2025-05-27': { 10: count, 11: count } }

  filtered.forEach((visit) => {
    const dt = new Date(visit.start_datetime);
    const day = dt.toISOString().split('T')[0]; // YYYY-MM-DD
    const hour = dt.getHours();

    if (!dayHourMap[day]) dayHourMap[day] = {};
    if (!dayHourMap[day][hour]) dayHourMap[day][hour] = 0;

    dayHourMap[day][hour]++;
  });

  // 3. Create dataset per day
  const hours = Array.from({ length: 24 }, (_, i) => `${i}:00`);
  const datasets = Object.keys(dayHourMap).map((day, idx) => {
    const colorHue = (idx * 50) % 360;
    return {
      label: day,
      data: Array.from({ length: 24 }, (_, hour) => dayHourMap[day][hour] || 0),
      backgroundColor: `hsl(${colorHue}, 70%, 60%)`,
      stack: 'visits',
    };
  });

  const data = {
    labels: hours,
    datasets,
  };

  const options = {
    responsive: true,
    plugins: {
      title: {
        display: true,
        text: 'Clubhouse Pool/Jacuzzi Visits by Hour and Day',
      },
      legend: {
        position: 'top',
      },
    },
    scales: {
      x: {
        stacked: true,
        title: { display: true, text: 'Hour of Day' },
      },
      y: {
        stacked: true,
        beginAtZero: true,
        title: { display: true, text: 'Number of Visits' },
      },
    },
  };

  return <Bar data={data} options={options} />;
};

export default PoolVisitsByHourAndDayChart;
